import {
    Form,
    Button
} from 'react-bootstrap'
import { NextPage } from 'next'
import React, { useState, useEffect } from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import CommentReplyItem from './CommentReplyItem'
import { useRouter } from 'next/router'

const CommentReplyList: NextPage<AppCommonProps> = ({
    t, item, contentReply, setContentReply, handleSubmitReply, handleEdit, onHandleUpdate, onHandleDelete,
    onHandleHide, isReply, setIsReply, setIsShowReplyInput, isShowReplyInput, showPicker, setShowPicker, videoUserID, profile
}: any) => {
    const { asPath } = useRouter()
    const isVideoDetailPage = asPath.indexOf('/video') === 0
    const onEmojiClick = (event: any, emojiObject: { emoji: any }) => {
        setContentReply(contentReply + emojiObject.emoji)
    }
    const handleOnChange = (e: any) => {
        setContentReply(e.target.value)
        const lines = e.target.value.split('\n')
        if (lines[lines.length - 1].match(/^\s*$/) && lines.length > 1) {
            setHeight(`${e.target.scrollHeight - 11}px`)
        } else if (lines.length === 1) {
            setHeight('39px')
        } else {
            setHeight(`${e.target.scrollHeight}px`)
        }
    }
    const [height, setHeight] = useState('39px')
    useEffect(() => {
        const isItemOwnerWithReplies = item.user_id === profile.id && item.replies.length > 0;  //Check if the current user should be the owner of the item
        let isReply;
        if (isVideoDetailPage) {
            const isVideoUser = videoUserID === profile.id;  //Check if the current user is the owner of this video
            isReply = isVideoUser || isItemOwnerWithReplies;
        } else {
            const isCurrentUser = profile.id === videoUserID.id;    //Check if the current user is the owner of this profile page
            isReply = isCurrentUser || isItemOwnerWithReplies;
        }
        setIsReply(isReply);
    }, [item, profile.id, isVideoDetailPage, videoUserID]);
    
    return (
        <div className="reply">
            <div>
                {item.replies.map((reply: any,index: any) => {
                    return <CommentReplyItem reply={reply} key={item.id} contentReply={contentReply}
                        setContentReply={setContentReply} handleEdit={handleEdit} onHandleUpdate={onHandleUpdate} onHandleDelete={onHandleDelete} onHandleHide={onHandleHide} 
                        videoUserID={videoUserID} profile={profile}/>
                })}
            </div>
            {isShowReplyInput && <div>
                <div className="picker-container">
                    <Form.Control as="textarea" value={contentReply}
                        onChange={(e) => { handleOnChange(e) }} style={{ height }} />
                    <div className="emoji-container">
                        <img
                            className="emoji-icon"
                            alt="true"
                            src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                            onClick={() => setShowPicker((val: any) => !val)}
                        />
                        <Button variant="primary" type="button" className="ac-btn-sm ac-btn-video rounded-left-0 ml-4 button-comment"
                            onClick={() => {
                                handleSubmitReply()
                                setHeight('39px')
                            }}>
                            送信
                        </Button>
                    </div>
                    {showPicker && (
                        <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
                    )}
                </div>
            </div>}
            {isReply && !isShowReplyInput && <p className="cursor-pointer" onClick={() => { setIsShowReplyInput(!isShowReplyInput) }}>返信</p>}
        </div>
    )
}


export default withI18n(CommentReplyList)
